import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["query"],
  _excluded2 = ["query"],
  _excluded3 = ["query"],
  _excluded4 = ["query"],
  _excluded5 = ["query"];
import http from 'hub-http/clients/apiClient';
const encodeHubIdsToBase64 = hubIds => {
  const hubIdsString = hubIds.join(',');
  return btoa(hubIdsString);
};
const buildMamQueryParams = (options, baseQuery = {}) => {
  const query = Object.assign({}, baseQuery);
  if ('destinationHubId' in options) {
    query.mamDestinationHubId = options.destinationHubId;
  } else if ('destinationHubIds' in options && options.destinationHubIds.length > 0) {
    query.mamDestinationHubIds = encodeHubIdsToBase64(options.destinationHubIds);
  }
  return query;
};
export const multiAccountHttpClient = {
  get: (path, options) => {
    const {
        query = {}
      } = options,
      restOptions = _objectWithoutPropertiesLoose(options, _excluded);
    const mamQuery = buildMamQueryParams(options, query);
    return http.get(path, Object.assign({
      query: mamQuery
    }, restOptions));
  },
  post: (path, options) => {
    const {
        query = {}
      } = options,
      restOptions = _objectWithoutPropertiesLoose(options, _excluded2);
    const mamQuery = buildMamQueryParams(options, query);
    return http.post(path, Object.assign({
      query: mamQuery
    }, restOptions));
  },
  put: (path, options) => {
    const {
        query = {}
      } = options,
      restOptions = _objectWithoutPropertiesLoose(options, _excluded3);
    const mamQuery = buildMamQueryParams(options, query);
    return http.put(path, Object.assign({
      query: mamQuery
    }, restOptions));
  },
  patch: (path, options) => {
    const {
        query = {}
      } = options,
      restOptions = _objectWithoutPropertiesLoose(options, _excluded4);
    const mamQuery = buildMamQueryParams(options, query);
    return http.patch(path, Object.assign({
      query: mamQuery
    }, restOptions));
  },
  delete: (path, options) => {
    const {
        query = {}
      } = options,
      restOptions = _objectWithoutPropertiesLoose(options, _excluded5);
    const mamQuery = buildMamQueryParams(options, query);
    return http.delete(path, Object.assign({
      query: mamQuery
    }, restOptions));
  }
};